<template>
  <div>
    <v-dialog width="600px" :value="true">
      <v-card>
        <v-card-title>
          <v-layout>
            <v-flex>
              <span class="headline">{{
                $t('Terms & Condition & Refund Prolicy')
              }}</span>
            </v-flex>
            <v-flex class="text-xs-right">
              <v-btn flat fab small @click="$emit('close')">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <h4>การเก็บรวบรวมและการใช้ข้อมูล</h4>
          <p class="mt-2">
            การเก็บรวบรวมและการใช้ข้อมูลบริษัทฯ จะเก็บรวบรวมข้อมูลชื่อ นามสกุล
            ที่อยู่การจัดส่ง เพศ ความสนใจส่วนตัวของท่าน และข้อมูลพื้นฐานอื่นๆ
            เมื่อท่านได้เชื่อมต่อกับระบบ
            โดยข้อมูลที่ถูกเก็บรวบรวมทางออนไลน์จะได้รับการเปิดเผยเฉพาะภายในเครือบริษัทฯเพื่อการดำเนินการภายในเท่านั้น
            เมื่อเสร็จสิ้นกระบวนการลงทะเบียนทั้งหมดแล้ว
            ท่านจะมีสิทธิทุกประการในการเป็นสมาชิกเว็บไซต์ ทั้งนี้
            รวมถึงการได้รับข้อมูลข่าวสาร
            สิทธิพิเศษและการเข้าร่วมกิจกรรมส่งเสริมการขายต่างๆ ของเว็บไซต์
            ข้อมูลส่วนบุคคลที่เราเก็บรวมรวมไว้นั้น จะถูกใช้ดังต่อไปนี้
          </p>
          <ul>
            <li>เพื่อการจัดส่งสินค้าที่ท่านสั่งซื้อ</li>
            <li>
              เพื่ออัพเดทข้อมูลการส่งสินค้า
              รวมไปถึงในกรณีที่ผู้ใช้บริการต้องการบริการอื่นๆ เพิ่มเติม
            </li>
            <li>เพื่อการให้ข้อมูลสินค้าที่เกี่ยวข้อง</li>
            <li>
              เพื่อวัตถุประสงค์ในการตรวจสอบการใช้งานเว็บไซต์ นอกจากนี้ทางบริษัทฯ
              ยังใช้ข้อมูลและสถิติที่รวบรวมต่างๆ ในการวิเคราะห์
              เพื่อคัดเลือกสินค้าและบริการที่เหมาะสมที่สุดสำหรับสมาชิก
              ช่วยปรับปรุงเว็บไซต์และบริการ และอาจให้ข้อมูลดังกล่าวแก่บุคคลอื่น
              ข้อมูลสถิติดังกล่าวจะไม่รวมถึงข้อมูลที่สามารถใช้ในการระบุตัวตนของใคร
            </li>
            <li>
              อีกทั้งบริษัทฯ อาจส่งอีเมลถึงท่านเพื่อแจ้งข้อมูลข่าวสาร
              สิทธิพิเศษและกิจกรรมส่งเสริมการขาย
            </li>
          </ul>
          <h4 class="mt-3">การรับประกันสินค้า</h4>
          <div class="mt-2">
            <div>สินค้าสำเร็จรูป เกรด A</div>
            <div>สินค้ากลุ่มเครื่องครัวสเตนเลสสตีล ซีกัล</div>
            <div>ระยะเวลารับประกัน ตลอดอายุการใช้งาน</div>
            <div>สินค้ากลุ่มเครื่องครัวนอนสติ๊กและเซรามิค ซีกัล</div>
            <div>
              ระยะเวลารับประกัน 1 ปี นับจากวันที่ซื้อสินค้า
              โดยต้องมีใบเสร็จรับเงินมาแสดง เพื่อเป็นหลักฐาน
            </div>
            <div>
              *ยกเว้นกลุ่มเครื่องครัวอัลทิเมท และ กระทะพรีเมียม มาร์เบิ้ล สโตน
              ระยะเวลารับประกัน 5 ปี โดยต้องมีใบเสร็จรับเงินมาแสดง
              เพื่อเป็นหลักฐาน
            </div>
            <div>สินค้ากลุ่มกล่องถนอมอาหารพลาสติก ซีกัล</div>
            <div>
              รับประกันตลอดอายุการใช้งาน เฉพาะตัวล็อกของฝากล่องหัก
              และซีลยางซิลิโคนฉีกขาดเท่านั้น
            </div>
            <div>สินค้ากลุ่มไฟฟ้า ซีกัล และจรวด</div>
            <div>
              ระยะเวลารับประกัน 1 ปี นับจากวันที่ซื้อสินค้า
              และลงทะเบียนการรับประกันเสร็จสมบูรณ์เท่านั้น
            </div>
            <div>สินค้ากลุ่มเครื่องครัวสเตนเลสสตีล จรวด</div>
            <div>
              ระยะเวลารับประกัน 1 ปี นับจากวันที่ซื้อสินค้า
              โดยต้องมีใบเสร็จรับเงินมาแสดง เพื่อเป็นหลักฐาน
            </div>
          </div>
          <div class="mt-2">
            สินค้าสำเร็จรูป เกรด B และ FGZ สินค้ากลุ่มไฟฟ้า ซีกัล และจรวด
            ระยะเวลารับประกัน 3 เดือน นับจากวันที่ซื้อสินค้า เฉพาะระบบไฟฟ้า
            โดยต้องมีใบเสร็จรับเงินมาแสดง เพื่อเป็นหลักฐาน
            สินค้ากลุ่มเครื่องครัวสเตนเลสสตีล เครื่องครัวนอนสติ๊กและเซรามิค
            ซีกัล และจรวด ไม่มีการรับประกัน
          </div>
          <h4 class="mt-3">เงื่อนไขการรับประกัน</h4>
          <ol class="mt-2">
            <li>
              การรับประกันนี้ครอบคลุมเฉพาะกรณีที่เกิดจากข้อบกพร่องในการผลิต
              หรือวัสดุชิ้นส่วนไม่ได้มาตรฐาน
            </li>
            <li>
              บริษัทฯ รับประกันเฉพาะการใช้สินค้าในครัวเรือนตามปกติ
              ไม่ครอบคลุมการใช้งานเพื่อประโยชน์ทางการค้า การใช้งานผิดลักษณะ
              หรือจากความประมาทในการใช้งาน หรือไม่ปฏิบัติตามคำแนะนำ
              รวมถึงการสึกหรอตามอายุใช้งาน
              หรือหมดอายุการใช้งานตามมาตรฐานที่โรงงานกำหนด
            </li>
            <li>
              บริษัทฯ
              ขอสงวนสิทธิ์ในการพิจารณาตัดสินว่าความเสียหายที่เกิดขึ้นเป็นความเสียหายจากการใช้งานตามปกติหรือไม่
              โดยพิจารณาจากสภาพของเครื่องครัวที่ปรากฏเท่านั้น
            </li>
            <li>
              รับประกันเฉพาะสินค้าที่จำหน่ายและใช้งานภายในประเทศไทยเท่านั้น
            </li>
            <li>
              บริษัทฯ ไม่มีภาระผูกพันเพิ่มเติมอื่น ๆ
              นอกเหนือจากการแทนที่สินค้าที่บกพร่อง และบริษัทฯ ไม่จำเป็นต้องซ่อม
              หรือเปลี่ยนสินค้าที่ไม่ได้มาพร้อมกับหลักฐานการซื้อขายที่ถูกต้อง
            </li>
            <li>
              ไม่รับประกันอุปกรณ์สิ้นเปลือง หรือเสื่อมจากการใช้งาน เช่น ซีลยาง,
              ชิ้นส่วนพลาสติก, ชุดก๊อก ฯลฯ (ยกเว้นกลุ่มกล่องอาหารพลาสติก
              รับประกันเฉพาะตัวล็อกของฝากล่องหัก และซีลยางซิลิโคนฉีกขาดเท่านั้น)
            </li>
          </ol>
          <div class="mt-3">
            ข้อมูลเพิ่มเติม
            <a href="http://www.seagull-brand.com" target="_blank">Seagull</a>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outline :color="theme.color" @click="$emit('close')">{{
            $t('Accept')
          }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ModalDialog from '@/components/ModalDialog.vue'
import { mapGetters } from 'vuex'
export default {
  props: {
    pageid: { default: null }
  },
  components: {
    ModalDialog
  },
  computed: {
    ...mapGetters({
      theme: 'getTheme'
    }),
    currentUrl() {
      return window.location.origin
    },
    currentUrlMin() {
      return window.location.hostname
    }
  }
}
</script>

<style scoped>
.term-and-condition p {
  text-indent: 30px;
}
</style>
